import React, { Fragment, useContext } from 'react';
import { warName, apiDomain } from '../..';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { formatDateWithWeekDay, getConfiguration, getSplitDesc } from '../../data/utils';
import { getLabel } from '../../data/labels';
import { getPrintCSS } from './printCSS2';

function getAlias(odd, bet, useCustomizedAlias) {
    const systemCode = getConfiguration().sys;
    let aliasList = [];
    // checking if there is an alias customization for this skin
    if (useCustomizedAlias) {
        let customizedAliasList = odd.aliasBySystemCode ? odd.aliasBySystemCode[systemCode] : null;
        if ((customizedAliasList == null || customizedAliasList.length === 0) && odd.aliasHandicapBySystemCode) {
            // searching it in the aliasByHandicapSystemCodeMap
            customizedAliasList = odd.aliasHandicapBySystemCode[`${systemCode}_${bet.handicap}`];
        }
        if (customizedAliasList != null && customizedAliasList.length > 0) {
            aliasList = customizedAliasList;
        }
    } else {
        if (odd.aliasListDefault != null && odd.aliasListDefault.length > 0) {
            aliasList = odd.aliasListDefault;	
        } else if(odd.aliasByHandicap != null && odd.aliasByHandicap[bet.handicap] != null) {
            aliasList = odd.aliasByHandicap[bet.handicap];
        }
    }

    if (aliasList.length > 0) {
        return aliasList[0];
    } else {
        return '-';
    }
}

function getMaxRows() {
    return 70;
}

function splitEventsInPages(tournaments) {
    const pages = [[]];
    const dates = [];
    const tournamentsByDate = {};
    tournaments.forEach(t => {
        t.events.forEach(function(match) {
            const timestamp = match.ts.split(' ')[0];  // Prendi solo la data
            if (tournamentsByDate[timestamp] == null) {
                tournamentsByDate[timestamp] = [];
                dates.push(timestamp);
            }
            match.sportDesc = t.sportDesc;
            match.categoryDesc = t.categoryDesc;
            match.tournamentDesc = t.descrizione || t.desc;
            const tournament = tournamentsByDate[timestamp].find(tournament => tournament.id === t.id);
            if (tournament === undefined) {
                tournamentsByDate[timestamp].push({
                    ...t,
                    events: [match]
                });
            } else {
                tournament.events.push(match);
            }
        });
    });
    dates.sort();
    let matches = [];
    dates.forEach(date => {
        const tournaments = tournamentsByDate[date];
        tournaments.forEach(t => {
            const formattedDate = formatDateWithWeekDay(`${date} 00:00`).dayMonth;
            const matchesList = t.events.sort((a, b) => a.ts.localeCompare(b.ts));
            matchesList.forEach(m => m.date = formattedDate);
            matches.push(...matchesList);
        });
    });
    let pagesIndex = 0;
    let currentId = '';
    let totalRows = 0;
    matches.forEach(m => {
        let rowsToAdd = 1;
        const id = `${m.date}_${m.is}_${m.ic}_${m.it}`;
        if (currentId !== id) {
            rowsToAdd++;
            currentId = id;
        }
        if (totalRows + rowsToAdd > getMaxRows()) {
            pages.push([]);
            pagesIndex++;
            totalRows = 0;
            rowsToAdd = 3;
        }
        pages[pagesIndex].push(m);
        totalRows += rowsToAdd;
    });

    return pages;
}

function renderOdds(matches, totalOdds) {
    let currentId = '';

    const groupings = [];
    let current = null;

    matches.forEach((match, matchIndex) => {
        const parts = formatDateWithWeekDay(match.ts).dayMonthTime.split(' - ');
        const formattedTime = parts[1];
        const id = `${match.date}_${match.is}_${match.ic}_${match.it}`;

        const renderHeader = id !== currentId;
        if (renderHeader) {
            currentId = id;

            current = [];
            groupings.push(current);

            current.push(
                <div key={currentId} className="rigaOrario" style={{gridTemplateColumns: `calc(2 * var(--info-width) + 2 * var(--desc-width)) calc(${totalOdds} * var(--base-width))`}}>
                    <div className="cell date" colSpan="4">{match.date}</div>
                    <div className="cell tournament-desc" colSpan="30">{match.categoryDesc} - {match.tournamentDesc}</div>
                </div>
            );
        }
        
        const [team1, team2] = getSplitDesc(match.desc);
        current.push(
            <Fragment key={matchIndex}>
                <div className={`row rigaValorizzata ${matchIndex % 2 ? 'even' : 'odd'}`} style={{gridTemplateColumns: `repeat(2, var(--info-width)) repeat(2, var(--desc-width)) repeat(${totalOdds}, var(--base-width))`}}>
                    <div className="cell">{match.al}</div>
                    <div className="cell">{formattedTime}</div>
                    <div className="cell team">{team1}</div>
                    <div className="cell team">{team2}</div>
                    {match.scs.map((bet, i) => {
                        return bet.odds.map((odd, oddIndex) => {
                            return (
                                <div key={oddIndex} className={`cell quota ${matchIndex % 2 ? 'even' : 'odd'}`}>
                                    {odd.value && odd.value > 0 ? odd.value : null}
                                </div>
                            );
                        })
                    })}
                </div>
            </Fragment>
        );
    });

    return groupings;
}

export function PrintIframeContent(props) {
    const conf = getConfiguration();
    const betslipContext = useContext(BetslipContext);
    const useCustomizedAlias = betslipContext.enableCustomAliases;
    const data = {
        groups: props.groups,
        groupByBet: props.groupByBet
    };

    if (data == null) {
        return null;
    }

    function onload() {
        const iframe = document.querySelector('iframe[title="print-odds-iframe"]');
        if (iframe == null) {
            return;
        }
        
        const cw = iframe.contentWindow;
        if (cw.logoLoaded) {
            return;
        }
        cw.print();
        cw.logoLoaded = true;
    }

    return (
        <>
            <style dangerouslySetInnerHTML={{__html: getPrintCSS()}} />
            {data.groups.map((tournaments, groupIndex) => {
                const pages = splitEventsInPages(tournaments);
                return (
                    <React.Fragment key={groupIndex}>
                        {pages.map((matches, pageIndex) => {
                            const firstMatchBets = matches[0].scs.filter(bet => {
                                const betId = `${bet.id}_${bet.handicap}`;
                                return data.groupByBet[betId] === groupIndex;
                            });
                            let totalOdds = 0;
                            firstMatchBets.forEach(b =>
                                totalOdds += b.odds.length
                            );
                            let offset = 3;

                            const groupings = renderOdds(matches, totalOdds);

                            return (
                                <React.Fragment key={pageIndex}>
                                    <div className="oddsTable">
                                        <div className="header-container">
                                            <img src={`${apiDomain}/${warName}/content/images/customer-logo/${conf.logo}`} className="customerLogo" onLoad={onload} />
                                        </div>
                                        <div className="table-body">
                                            {pageIndex === 0 &&
                                                <>
                                                    <div className="headerPrincipale" style={{gridTemplateColumns: `calc(2 * var(--info-width)) calc(2 * var(--desc-width)) repeat(${totalOdds}, var(--base-width))`}}>
                                                        <div className="cell info">{getLabel('prematch_page.print_bets.print_window_table_header_info')}</div>
                                                        <div className="cell event">{getLabel('prematch_page.print_bets.print_window_table_header_event')}</div>
                                                        {firstMatchBets.map((bet, betIndex) => {
                                                            const colSpan = bet.odds.length;
                                                            return (
                                                                <div key={betIndex} className="cell headerDescScomm" style={{gridColumn: `${offset} / ${offset += colSpan}`}}>{bet.desc}</div>
                                                            );
                                                        })}
                                                        {firstMatchBets.map(bet =>
                                                            bet.odds.map((odd, oddIndex) =>
                                                                <div key={oddIndex} className="cell quota">
                                                                    {getAlias(odd, bet, useCustomizedAlias)}
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                    <div className="subHeader" style={{gridTemplateColumns: `repeat(2, var(--info-width)) repeat(2, var(--desc-width)) repeat(${totalOdds}, var(--base-width))`}}>
                                                        <div className="cell alias">{getLabel('prematch_page.print_bets.print_window_table_header_alias')}</div>
                                                        <div className="cell time">{getLabel('prematch_page.print_bets.print_window_table_header_time')}</div>
                                                        <div className="cell team">{getLabel('general.team_home')}</div>
                                                        <div className="cell team">{getLabel('general.team_away')}</div>
                                                        {firstMatchBets.map(bet =>
                                                            bet.odds.map((odd, oddIndex) =>
                                                                <div key={oddIndex} className="cell quota">
                                                                    {odd.desc}
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                </>
                                            }
                                            {groupings.map((elements, i) =>
                                                <div key={i} className="grouping">
                                                    {elements}
                                                </div>
                                            )}
                                            </div>
                                            {/* <tfoot>
                                                <tr>
                                                    <th colSpan="34">
                                                        <img src={`${apiDomain}/${warName}/content/images/customer-logo/${conf.logo}`} className="customerLogo" />
                                                    </th>
                                                </tr>
                                            </tfoot> */}
                                    </div>
                                </React.Fragment>
                            );
                        })}
                    </React.Fragment>
                );
            })}
        </>
    );
}

export default PrintIframeContent;